import { KeyRound } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { oidcAuthWeb } from '../web-manifest.js';
import { OidcIcon } from './OidcIcon';

export default createWebRegistrationFromManifest(
  oidcAuthWeb,
  {
    EnterpriseAuthorizationPage: () =>
      import('./EnterpriseAuthorizationPage').then((m) => ({
        default: m.EnterpriseAuthorizationPage,
      })),
  },
  {
    icons: { KeyRound },
    authProviders: {
      oidc: {
        icon: OidcIcon,
        benefit: 'Enables single sign-on through your enterprise identity provider',
      },
    },
  },
);
